'use es6';

import React from 'react';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import unescapedText from 'I18n/utils/unescapedText';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';

var LoadingErrorPage = function LoadingErrorPage() {
  return React.createElement(UIErrorMessage, {
    title: unescapedText('loadingErrorHeader')
  }, React.createElement("p", null, React.createElement(FormattedHTMLMessage, {
    message: "loadingErrorSubHeader"
  })));
};

export default LoadingErrorPage;